export default (value) => {
  if (value == null || value === '') {
    return 'Undefined recipient'
  }

  return value
}
